import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import MembershipBreakdownLearnMore from "./smartComponents/membershipBreakdownLearnMore";
import MembershipBreakdownPieChart from "./smartComponents/membershipBreakdownPieChart";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import MembershipBreakdownTable from "./smartComponents/membershipBreakdownTable";
import SectionToggle from "../../../../components/sectionToggle/sectionToggle";
import SingleDatePicker from "./smartComponents/singleDatePicker";
import { actionCreators } from "./redux/membershipBreakdownSaga";
import IncludeZeroSales from "./smartComponents/includeSales";
import StatusTypes from "./smartComponents/statusTypes";
import GroupBy from "./smartComponents/groupBy";
import "./membershipBreakdownModule.css.scss";

const MembershipBreakdownModule = (props) => {
  const dispatch = useDispatch();
  const { organization_name } = useSelector((state) => state.commonReducer.commonProps);
  const {
    isLoading,
    membershipsInfo: { data = [] },
    tableLoading,
    initialRequest
  } = useSelector((state) => state.membershipBreakdown);

  useEffect(() => {
    if (!initialRequest) {
      dispatch(actionCreators.fetchCurrentUser(props));
    }
  }, []);

  const getContent = () => {
    return (
      <>
        <div id="membershipBreakdownModule">
          <div className="dropdown dropdown-actions actions">
            <div className="filters-wrapper">
              <div className="select-box" style={{ width: 170 }}>
                <p>Group by</p>
                <GroupBy />
              </div>

              <div className="select-box include-sales-dropdown" style={{ width: 120 }}>
                <p>Include $0 Sales</p>
                <IncludeZeroSales />
              </div>
            </div>
            <SingleDatePicker />
          </div>
          {data.length > 0 ? (
            tableLoading ? (
              <LoadingAnimation />
            ) : (
              <>
                <MembershipBreakdownTable />
                <div className="pie-chart">
                  <MembershipBreakdownPieChart />
                </div>
              </>
            )
          ) : (
            <p
              style={{
                textAlign: "center",
                fontSize: "35px",
                color: "#86919F",
                height: "400px",
                lineHeight: "400px"
              }}
            >
              No data available for selected date.
            </p>
          )}
        </div>
      </>
    );
  };

  return (
    <SectionToggle
      isLoading={isLoading}
      title="Membership Breakdown by"
      content={getContent()}
      learnMore={
        <>
          <StatusTypes />
          <MembershipBreakdownLearnMore organizationName={organization_name} />
        </>
      }
    />
  );
};

export default React.memo(MembershipBreakdownModule);
